module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontmatter",
    attrs: {
      "id": "fm2"
    }
  }, [_c('p', {
    staticClass: "ach"
  }, [_vm._v("By Nicole Peeler")]), _vm._v(" "), _c('p', {
    staticClass: "achs"
  }, [_vm._v("J"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("ANE")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("RUE")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcap"
  }, [_vm._v("OVELS")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_vm._v("Tempest Rising")]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_vm._v("Tracking the Tempest")]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_vm._v("Tempest's Legacy")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d6c998","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780316076012_epub_fm2_r1.vue
// module id = 63
// module chunks = 0